export default "__VITE_ASSET__CG_pnr7s__"